import { StrictMode, use, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./styling/index.css";
import App from "./App";
import { SXAlertsContainer } from "./components/ui-components/SXAlert/SXAlertContainer";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { useAppSelector } from "./app/hooks";
import { Auth0Provider } from "@auth0/auth0-react";
import { selectConfig, useConfig, configState } from "./features/config/configSlice";

const container = document.getElementById("app");

function Main() {
  const [fetchConfig] = useConfig();
  const config = useAppSelector(selectConfig);

  const redriectCallback = (appState: any) => {
    window.history.replaceState({}, document.title, window.location.pathname);

    // Redirect to the URL stored in localStorage or fallback to home page
  };
  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    config && (
      <Auth0Provider
        domain={config.REACT_APP_AUTH_DOMAIN}
        clientId={config.REACT_APP_AUTH_CLIENTID}
        useRefreshTokensFallback={false}
        authorizationParams={{
          redirect_uri: window.location.origin + "/callback",
          audience: config.REACT_APP_AUTH_AUDIANCE,
          scope: config.REACT_APP_AUTH_SCOPE,
        }}
        onRedirectCallback={redriectCallback}
        useRefreshTokens={false}
        cacheLocation="memory"
      >
        <SXAlertsContainer />
        <App />
      </Auth0Provider>
    )
  );
}

if (container) {
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <Main />
      </Provider>
    </StrictMode>,
  );
}
